<template>
    <div class="tw-text-center tw-grid tw-gap-y-10 container">
        <div>
            <div class="tw-font-semibold tw-text-left tw-text-base">
                Step 1 : อัพโหลดโลโก้ของคุณ
            </div>
            <div class="guide-section">
                <label class="upload-image-field" v-if="!logoSrc">
                    <input
                        type="file"
                        class="tw-hidden"
                        @change="e => onFileChange(e, 'logo')"
                    />
                    <div class="upload-image-guide">
                        <i
                            class="fa fa-cloud-upload fa-5x"
                            aria-hidden="true"
                        ></i>
                        <div class="tw-text-xl tw-mb-2">
                            Upload your logo
                        </div>
                        <div class="tw-text-xs">
                            ขนาดภาพไม่เกิน 2 MB
                        </div>
                        <div class="tw-text-xs">
                            Recommended : 1920x1080 pixels, 1280x720 pixels
                        </div>
                    </div>
                </label>
                <div v-else class="image-preview-container">
                    <img :src="logoSrc" alt="logo" class="image-preview" />
                    <i
                        class="fa fa-times-circle fa-3x tw-text-black"
                        @click="() => removeImage('logo')"
                        aria-hidden="true"
                    ></i>
                </div>
            </div>
        </div>
        <div>
            <div class="tw-font-semibold tw-text-left tw-text-base">
                Step 2 : พิมพ์ชื่อร้านค้าของคุณ
            </div>
            <div class="guide-section">
                <div
                    class="shop-title"
                    style="font-size: 26px; color: rgb(227, 108, 9);"
                    contenteditable="true"
                    data-placeholder="พิมพ์ชื่อร้านค้า..."
                    @input="e => onInput('shopName', e.target.innerHTML)"
                ></div>
            </div>
        </div>
        <div>
            <div class="tw-font-semibold tw-text-left tw-text-base">
                Step 3 : พิมพ์คำอธิบายร้านค้าของคุณ
            </div>
            <div class="guide-section">
                <div
                    contenteditable="true"
                    data-placeholder="พิมพ์คำอธิบายร้านค้า..."
                    @input="e => onInput('shopDescription', e.target.innerHTML)"
                ></div>
            </div>
        </div>
        <div>
            <div class="tw-font-semibold tw-text-left tw-text-base">
                Step 4 : อัพโหลดรูปภาพเพิ่มเติมเกี่ยวกับร้านค้าของคุณ
            </div>
            <div class="guide-section">
                <label class="upload-image-field" v-if="!imageSrc">
                    <input
                        type="file"
                        class="tw-hidden"
                        @change="e => onFileChange(e, 'image')"
                    />
                    <div class="upload-image-guide">
                        <i
                            class="fa fa-cloud-upload fa-5x"
                            aria-hidden="true"
                        ></i>
                        <div class="tw-text-xl tw-mb-2">
                            Upload your image
                        </div>
                        <div class="tw-text-xs">
                            ขนาดภาพไม่เกิน 2 MB
                        </div>
                        <div class="tw-text-xs">
                            Recommended : 1920x1080 pixels, 1280x720 pixels,
                            1080x1080 pixels
                        </div>
                    </div>
                </label>
                <div v-else class="image-preview-container">
                    <img :src="imageSrc" alt="image" class="image-preview" />
                    <i
                        class="fa fa-times-circle fa-3x tw-text-black"
                        @click="() => removeImage('image')"
                        aria-hidden="true"
                    ></i>
                </div>
            </div>
        </div>
        <div class="tw-w-full text-center tw-mb-10">
            <button
                type="button"
                class="btn btn-sm btn-default tw-mr-1"
                @click="handleSkip"
            >
                ข้าม
            </button>
            <button
                type="button"
                class="btn btn-sm btn-success"
                data-dismiss="modal"
                :disabled="
                    !form.shopName ||
                        !form.shopDescription ||
                        !logoSrc ||
                        !imageSrc
                "
                @click="handleSubmit"
            >
                บันทึก
            </button>
        </div>
    </div>
</template>

<script>
export default {
    comonents: {},
    props: {
        shop: {
            required: true,
            type: String
        }
    },
    data() {
        return {
            form: {
                shopName: "",
                shopDescription: ""
            },
            logoSrc: "",
            imageSrc: "",
            logo: null,
            image: null,
            imageDir: "/guide"
        };
    },

    methods: {
        onInput(name, value) {
            this.form[name] = value;
        },
        async onFileChange(e, type) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }
            const file_size = files[0].size / 1024 / 1024;
            const file_name = files[0].name;
            const re = /(\.jpg|\.jpeg|\.png)$/i;
            if (file_size > 2) {
                this.messageAlert(
                    "error",
                    "ขนาดภาพใหญ่ไปนะ",
                    "TwT ขอโทษนะ กรุณาใช้ภาพขนาดไม่เกิน 2mb"
                );
            } else if (!re.exec(file_name)) {
                this.messageAlert(
                    "error",
                    "ไฟล์นี้ใช้ไม่ได้นะ",
                    "TwT ขอโทษนะ กรุณาใช้รูปภาพประเภท jpg, jpeg, png"
                );
            } else {
                if (type === "logo") {
                    this.logo = files[0];
                } else {
                    this.image = files[0];
                }
                this.previewImage(files[0], type);
            }
        },
        previewImage(file, type) {
            if (type === "logo") {
                this.logoSrc = URL.createObjectURL(file);
            } else {
                this.imageSrc = URL.createObjectURL(file);
            }
        },
        removeImage(type) {
            if (type === "logo") {
                this.logoSrc = "";
                this.logo = null;
            } else {
                this.imageSrc = "";
                this.image = null;
            }
        },
        handleSkip() {
            axios
                .post(`/backend/s/${this.shop}/skip-wizard`)
                .then(res => {
                    let url = `/backend/s/${this.shop}/salepages`;
                    window.location.href = url;
                })
                .catch(err => {
                    this.messageAlert(
                        "error",
                        "เกิดข้อผิดพลาด",
                        "กรุณาลองใหม่อีกครั้ง"
                    );
                });
        },
        async uploadImage(imageFile) {
            let formData = new FormData();
            formData.append("image", imageFile ? imageFile : "");
            formData.append("imageDir", this.imageDir);

            const response = await axios
                .post(`/ajax/s/${this.shop}/upload-image`, formData)
                .then(res => {
                    const imageUrl = res.data.imageUrl;
                    return imageUrl;
                })
                .catch(err => {
                    this.messageAlert(
                        "error",
                        "เกิดข้อผิดพลาด",
                        "กรุณาลองใหม่อีกครั้ง"
                    );
                });
            return response;
        },
        async handleSubmit() {
            const logoSrc = await this.uploadImage(this.logo);
            const otherSrc = await this.uploadImage(this.image);
            const logoImage = {
                type: "image",
                body: "",
                image_url: logoSrc
            };
            const otherImage = {
                type: "image",
                body: "",
                image_url: otherSrc
            };
            const shopName = {
                type: "text",
                body: `<p style="text-align: center;"><span style="font-size: 26px; color: rgb(227, 108, 9);"><strong>${this.form.shopName}</strong></span></p>`
            };
            const shopDescription = {
                type: "text",
                body: `<p style="text-align: center;">${this.form.shopDescription}</p>`
            };

            let formData = {
                title: this.form.shopName,
                description: this.form.shopDescription,
                bodies: [logoImage, shopName, shopDescription, otherImage]
            };
            axios
                .post(`/backend/s/${this.shop}/guide-salepage`, formData)
                .then(() => {
                    let url = `/backend/s/${this.shop}/salepages`;
                    window.location.href = url;
                })
                .catch(err => {
                    this.messageAlert(
                        "error",
                        "เกิดข้อผิดพลาด",
                        "กรุณาลองใหม่อีกครั้ง"
                    );
                });
        },
        messageAlert(type, title, text) {
            this.$swal({
                icon: type,
                title: title,
                text: text,
                showConfirmButton: true
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.guide-section {
    border: 1px solid var(--primary-color);
    border-radius: 5px;
    padding: 20px;
    margin-top: 10px;
}
.upload-image {
    &-field {
        border: 1px solid #d8d8d8;
        border-radius: 5px;
        width: 100%;
        max-width: 600px;
        aspect-ratio: 16/9;
        background: #f4f4f4;
        cursor: pointer;
        margin: auto;
    }
    &-guide {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        flex-flow: column;
        padding: 12px;
    }
}
.image-preview {
    width: 100%;
    height: 100%;
    max-width: 600px;

    &-container {
        width: fit-content;
        position: relative;
        margin: auto;

        i.fa {
            position: absolute;
            top: 12px;
            right: 12px;
            cursor: pointer;
            border-radius: 9999px;
            background: white;
            width: 36px;
            height: 36px;
            display: flex;
            align-items: center;
        }
    }
}
[contenteditable="true"] {
    width: fit-content;
    margin: auto;
    text-align: left;
}
.shop-title[contentEditable="true"]:empty:before {
    color: #f6a15a;
}
[contentEditable="true"]:empty:before {
    content: attr(data-placeholder);
    color: #b0b0ad;
    cursor: text;
}
[contenteditable="true"]:focus {
    outline: 0px solid transparent;
}
</style>
